import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

const POLL_INTERVAL = 5000

export default class extends Controller {
  static values = { pending: Boolean }

  connect() {
    if (!this.pendingValue) return

    this.checkStateInterval = POLL_INTERVAL
    this.#scheduleStateCheck()
  }

  #scheduleStateCheck() {
    setTimeout(this.#checkState.bind(this), this.checkStateInterval)
  }

  async #checkState() {
    let response = await get(
      `${window.location.href}_async`,
      {
        responseKind: 'turbo-stream',
      },
    )
    if (response.statusCode === 204) {
      this.#scheduleStateCheck()
    }
  }
}
